<!-- <div class="flex overflow-y-auto h-screen justify-content-center">
  <div class="w-full md:max-w-main-container">
    <div class="flex flex-column md:flex-row secondary">
      <app-sidebar></app-sidebar>
      <div class="layout-main-container w-full min-h-screen md:border-1 md:surface-border px-5 md:px-3 py-3 md:py-6 pb-8">
        <div class="pb-8">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div> -->


<main class="dashboard admin-layout">
  <!-- <div class="dashboard__background" style="background-image: url('assets/images/backgrounds/background-admin.jpg');"></div> -->
  <div class="dashboard__block">
    <div class="dashboard__container" *ngIf="showComponent">
      <app-sidebar [isOpen]="displaySidebar" (closeSidebar)="toggleSidebar()"></app-sidebar>
      
      <div class="dashboard__content">
        <app-header (toggleSidebar)="toggleSidebar()"></app-header>
        
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</main>
